import { render, staticRenderFns } from "./terms.vue?vue&type=template&id=a443bf66&scoped=true&"
var script = {}
import style0 from "./terms.vue?vue&type=style&index=0&id=a443bf66&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../RetirementPlanner.Demo/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a443bf66",
  null
  
)

export default component.exports